// Animate JS
//
// See: https://github.com/jshjohnson/Animate
// ex.: data-animate data-animation-classes="animated inUpSmall" data-animation-reverse="true"
//

var fn_data_animate = function () {
  var animate = new Animate({
      target: '[data-animate]',
      animatedClass: 'animated',
      offset: [0.25, 0.25],
      delay: 0,
      remove: true,
      scrolled: false,
      reverse: false,
      onLoad: true,
      onScroll: true,
      onResize: false,
      disableFilter: false,
      callbackOnInit: function() {},
      callbackOnInView: function(el) {},
      callbackOnAnimate: function(el) {},
  });
  animate.init();
}
